import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Building2, Coins, Search, Sparkles } from 'lucide-react';
import { SERVICES } from '../mock';
import Newsletter from '../components/Newsletter';
import SEO from '../components/SEO';

const ICONS = { vorsorge: Search, immobilien: Building2, alphalane: Sparkles, edelmetalle: Coins };

export default function Angebot() {
  return (
    <div>
      <SEO
        path="/angebot"
        title="Unser Angebot – Vier Wege zum finanziellen Erfolg"
        description="Immobilien, Alphalane AI Trading, verlorenes Vorsorgegeld & Edelmetalle. Vier bewährte Anlageklassen für nachhaltigen Vermögensaufbau in der Schweiz."
      />
      <section className="pt-36 pb-16 px-6 lg:px-10">
        <div className="max-w-6xl mx-auto text-center">
          <div className="text-xs uppercase tracking-[0.28em] text-[#d4b574] mb-4">Unsere Angebote</div>
          <h1 className="font-serif-display text-5xl md:text-7xl text-[#f5efe3] leading-[1.05]">
            Lösungen für <span className="italic text-gold-grad">deine Ziele</span>
          </h1>
          <p className="mt-6 text-[#9a9285] text-lg max-w-2xl mx-auto">
            Vier Anlageklassen, ein Ziel: nachhaltiger Vermögensaufbau, inflationsgeschützt und steueroptimiert.
          </p>
        </div>
      </section>

      <section className="px-6 lg:px-10 pb-24">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.id] || Sparkles;
            return (
              <Link
                key={s.id}
                to={s.href}
                className="card-glow group relative overflow-hidden rounded-2xl border border-white/8 bg-[#0e0e0c]"
              >
                <div className="relative h-64 overflow-hidden">
                  <img src={s.image} alt={s.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0e0e0c] via-[#0e0e0c]/40 to-transparent" />
                  <div className="absolute top-5 left-5 w-12 h-12 rounded-full bg-[#0a0a0c]/80 backdrop-blur border border-[#d4b574]/30 flex items-center justify-center text-[#e8d5a8]">
                    <Icon size={18} />
                  </div>
                </div>
                <div className="p-8">
                  <div className="text-[10px] uppercase tracking-[0.24em] text-[#d4b574] mb-2">0{i + 1}</div>
                  <h3 className="font-serif-display text-2xl md:text-3xl text-[#f5efe3] group-hover:text-[#e8d5a8] transition-colors leading-snug">{s.title}</h3>
                  <p className="mt-3 text-sm text-[#9a9285] leading-relaxed">{s.excerpt}</p>
                  <div className="mt-6 inline-flex items-center gap-2 text-sm text-[#d4b574] group-hover:gap-3 transition-all">
                    Mehr dazu <ArrowRight size={14} />
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </section>

      <Newsletter />
    </div>
  );
}
